















import { defineComponent } from '@vue/composition-api';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import ColumnContainer from '../layouts/columns/ColumnContainer.vue';
import PaddedContent from '../layouts/columns/PaddedContent.vue';

export default defineComponent({
	components: {
		FontAwesomeIcon,
		ColumnContainer,
		PaddedContent,
	},
});
